import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useLightStyles = makeStyles({
    greenLight: {
        background: `radial-gradient(#1D3C34 0% ,#1D3C3488 15% ,transparent 70%)`
    },
    pinkLight: {
        background: `radial-gradient(#471A4F 0% ,#471A4F88 15% ,transparent 70%)`
    },
    purpleLight: {
        background: `radial-gradient(#322A41 0% ,#322A4188 15% ,transparent 50%)`
    }
});

interface Props {
    className: string;
}

export const GreenLight = ({ className }: Props) => {
    const classes = useLightStyles();
    return <div className={clsx(classes.greenLight, className)} />;
};
export const PinkLight = ({ className }: Props) => {
    const classes = useLightStyles();
    return <div className={clsx(classes.pinkLight, className)} />;
};
export const PurpleLight = ({ className }: Props) => {
    const classes = useLightStyles();
    return <div className={clsx(classes.purpleLight, className)} />;
};


const useLightsBackground = makeStyles({
    lights: {
        width: '50vmax',
        height: '50vmax'
    },
    lightGreen: {
        position: 'fixed',
        bottom: '-20vmax',
        right: '-25vmax'
    },
    lightPurple: {
        position: 'fixed',

        top: '-22vmax',
        left: '-22vmax'
    },
    lightPink: {
        position: 'fixed',
        bottom: '-25vmax',
        left: '-25vmax'
    },
});


export const FixedBackgroundLight = () => {
    const classes = useLightsBackground()
    return (
        <>
            <GreenLight className={clsx(classes.lights, classes.lightGreen)} />
            <PinkLight className={clsx(classes.lights, classes.lightPink)} />
            <PurpleLight className={clsx(classes.lights, classes.lightPurple)} />
        </>
    );
};
